import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Menu, Dropdown, Affix,Button, Modal, Form, Input, notification } from "antd";
import { decode as tokenDecoder } from "../../utils/tokenDecoder";
import { Link, NavLink, useHistory } from "react-router-dom";

import { loginAction } from "../../redux/actions/authActions";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  toolbarTop: {
    minHeight: 70,
    display: "block",
    backgroundColor: "#fff",
    opacity: 1,
    boxShadow: "2px 2px #00F0FF",
  },
  navItem: {
    marginTop: 15,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));

const LandingPageAppBar = ({ loginAction, auth }) => {
  const classes = useStyles();
  const history = useHistory();

  const token = localStorage.getItem("x-auth-token");
  const userData = token && tokenDecoder(token);

  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    loginAction(values);
    // dispatch({ type: LOGIN, payload: values });
  };

  useEffect(() => {
    if (auth.login.loginData) {
      notification.success({ message: auth.login.loginData?.message });
      const token = localStorage.getItem("x-auth-token");
      const { role, firstName } = tokenDecoder(token);
      role === "admin" ? history.push("/dashboard") : history.push("/home");
      window.location.reload();
      setLoading(false);
    }
    if (auth.login.loginError) {
      notification.error({ message: auth.login.loginError?.error });
      setLoading(false);
    }
  }, [auth.login.loginData, auth.login.loginError]);


  return (
    <>
      <div className="card form-container">
        <div className="text-title">
          <strong>Sign in to your account</strong>
        </div>
        <Form
          layout="vertical"
          hideRequiredMark
          onFinish={onFinish}
          className="mb-4"
          initialValues={{ email: null, password: null }}
        >
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                message: "Please input your e-mail address",
              },
            ]}
          >
            <Input size="large" placeholder="Email" type="email" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Please input your password" },
            ]}
          >
            <Input.Password
              size="large"
              type="password"
              placeholder="Password"
            />
          </Form.Item>
          <div style={{background:"#038585"}}>   <Button
            type="ghost"
            size="large"
            className="container-100"
            htmlType="submit"
            loading={loading}
            style={{color:"#fff"}}
          >
            <strong>{loading ? "Authenticating" : "Sign in"}</strong>
          </Button></div>
        
        </Form>
      </div> 
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, { loginAction })(LandingPageAppBar);
